<!-- NEOIQ-2427: reuses the exact visual language (class names) of the established Peer-to-Peer
     success screen (shared-peer-to-peer-success.component.scss, imported below) since that
     design is already confirmed against Figma. Data bindings below use this component's own
     properties (`transaction`/`senderInfo`/`recipientInfo`), not the P2P flow's `transferResponse`/`userInfo`. -->
<div class="customer-success-cash-in-modal">
    <div #pdfExport class="customer-operation-holder">
        <div class="customer-operation-header">
            <div class="fw-500 customer-operation-header-amount">Amount</div>
            <div class="customer-operation-header-value mt-2">
                {{ transaction?.amount | number : amountDecimals }} <span class="currency-sub-text">{{ transaction?.currency }}</span>
            </div>
            <div
                [ngClass]="{ 'customer-operation-header-success': isMoneySent, 'customer-operation-header-failed': !isMoneySent }"
                class="d-flex align-items-center mt-2"
            >
                <mat-icon [svgIcon]="isMoneySent ? 'success' : 'failure'"></mat-icon>
                <div class="ms-1">{{ isMoneySent ? 'Money sent successfully' : errorDetails?.title }}</div>
            </div>

            <div *ngIf="isMoneySent" class="d-flex align-items-center justify-content-between customer-operation-details pt-2">
                <div
                    class="me-3 badge-gray text-truncate"
                    [title]="'Receiver will receive: ' + (transaction?.amount | number : amountDecimals) + ' ' + transaction?.currency"
                >
                    Receiver will receive: {{ transaction?.amount | number : amountDecimals }} {{ transaction?.currency }}
                </div>
                <div class="middle-border reference text-truncate" [title]="'Ref: ' + transaction?.transaction_id">Ref: {{ transaction?.transaction_id }}</div>
                <div class="ps-3">{{ transaction?.created | date : 'd MMM yyyy' }}</div>
            </div>
        </div>

        <div *ngIf="!isMoneySent" class="failure-reason d-flex flex-column w-100 align-items-start my-2 px-3">
            <div class="ms-1 failure-title">{{ errorDetails?.title }}</div>
            <div class="failure-sub-title">{{ errorDetails?.message }}</div>
        </div>

        <mat-card *ngIf="isMoneySent" class="rounded-3 shadow-none overflow-hidden mb-3 p-0">
            <mat-card-content class="p-0 rounded-4">
                <div class="customer-operation-summary px-3 pt-3">
                    <div class="d-flex justify-content-between fw-500 mb-3">
                        <div>Transfer amount</div>
                        <div>{{ transaction?.amount | number : amountDecimals }} {{ transaction?.currency }}</div>
                    </div>
                    <div class="d-flex justify-content-between fw-500 my-3">
                        <div>Fee</div>
                        <div>{{ transaction?.fee_amount | number : amountDecimals }} {{ transaction?.currency }}</div>
                    </div>
                </div>
                <div class="d-flex justify-content-between fw-500 mt-2 p-3 final-summary">
                    <div class="lh-1">Total</div>
                    <div class="lh-1">{{ total | number : amountDecimals }} {{ transaction?.currency }}</div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card *ngIf="isMoneySent" class="rounded-3 shadow-none overflow-hidden mb-3 p-0">
            <mat-card-content class="p-0 rounded-4">
                <div class="d-flex justify-content-between fw-500 p-3 final-summary">
                    <div class="lh-1">Sender</div>
                    <div class="lh-1"></div>
                </div>
                <div class="customer-operation-summary px-3 pt-3">
                    <div class="d-flex align-items-center justify-content-between fw-500 mb-3">
                        <div class="ps-2">
                            <h6 class="customer-title">{{ senderInfo?.name }}</h6>
                            <div class="customer-info">{{ formattedSenderMobile }}</div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div>Wallet:</div>
                            <div class="px-2 d-flex align-items-center">
                                <img
                                    [src]="'/assets/currency-flags/' + transaction?.currency + '-flag.svg'"
                                    [alt]="transaction?.currency"
                                    class="currency-img rounded-circle me-1"
                                />
                                <div class="ps-1">{{ transaction?.currency }}</div>
                            </div>
                            <div>****{{ transaction?.sender_account_id?.slice(-4) }}</div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card *ngIf="isMoneySent" class="rounded-3 shadow-none overflow-hidden mb-3 p-0">
            <mat-card-content class="p-0 rounded-4">
                <div class="d-flex justify-content-between fw-500 p-3 final-summary">
                    <div class="lh-1">Receiver</div>
                    <div class="lh-1"></div>
                </div>
                <div class="customer-operation-summary px-3 pt-3">
                    <div class="d-flex align-items-center justify-content-between fw-500 mb-3">
                        <div class="ps-2">
                            <h6 class="customer-title">{{ maskedRecipientName }}</h6>
                            <div class="customer-info">{{ formattedRecipientMobile }}</div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div>Wallet:</div>
                            <div class="px-2 d-flex align-items-center">
                                <img
                                    [src]="'/assets/currency-flags/' + transaction?.currency + '-flag.svg'"
                                    [alt]="transaction?.currency"
                                    class="currency-img rounded-circle me-1"
                                />
                                <div class="ps-1">{{ transaction?.currency }}</div>
                            </div>
                            <div>****{{ transaction?.recipient_account_id?.slice(-4) }}</div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="customer-operation-actions d-flex justify-content-start align-items-center">
        <button
            *ngIf="isMoneySent"
            [disableRipple]="true"
            class="rounded-pill text-white customer-operation-btn btn me-2"
            color="primary"
            mat-flat-button
            (click)="downloadReceipt()"
        >
            <span>Download Receipt</span>
        </button>
        <button (click)="done()" [disableRipple]="true" class="rounded-pill text-white customer-operation-cancel-btn btn" color="primary" mat-flat-button>
            <span>Done</span>
        </button>
    </div>
</div>
